import React from 'react';

import { convertPadding } from '../../utils/paddings';
import { slugify } from '../../utils/slugify';

export default function ModuleWrapper({ className = '', roundedCorners = false, paddings, children, name = "", anchor = "", ...restProps }) {
  const paddingTop = convertPadding(paddings?.top || 'none', 'top');
  const paddingBottom = convertPadding(paddings?.bottom || 'none', 'bottom');
  const rounding = roundedCorners === true ? 'rounded-2xl': '';

  const id = anchor ? anchor : slugify(name) || null;

  return (
    <div className={`mx-0 my-0 ${className} ${rounding} ${paddingTop} ${paddingBottom} `} id={id} {...restProps}>
      {children}
    </div>
  );
}